import React, {Fragment} from 'react';

import styles from '../../../../styles/modules/components/homecare/selection.module.scss';
import HomecareCard from './HomecareCard';
import {getStaticPath} from '../../../../utils';
import { NextArrow, PrevArrow } from '../../../common/ui-components/carosel';
import Hidden from '@material-ui/core/Hidden';
import { ThemeProvider } from '@material-ui/styles';
import theme from '../../../mui-overrides';
import Slider from 'react-slick';


const HomecarePlans = (props:any) => {
  const [hover, set_hover] = React.useState<number | null>(null)
  const [small_screen,setLyaout] = React.useState<boolean>(true);

  const setMousePosition = (index:any) => {
    set_hover(index)
  }

  const resetMousePosition = () => {
    set_hover(null)
  }

  const formatProducts = (products) => {
    let formattedProducts = []
    if(props.enablePremium) {
      formattedProducts = products ? products.filter((product) => product.title !== '1 Year HomeCare Premium') : []
    } else {
      formattedProducts = products ? products.filter((product) => !product.title.toLowerCase().includes('pkg')) : []
    }
    return formattedProducts
  }

  const settings = {
      slidesToShow: 1,
      dots: true,
      speed: 800,
      slidesToScroll: 1,
      infinite: true,
      nextArrow: <></>,
      prevArrow: <></>,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 20000,
  }

  React.useEffect(() => {
      window.innerWidth > 767 ? setLyaout(false) : setLyaout(true);
      window.addEventListener('resize',(e) => {
          if(window.innerWidth > 767) {
              small_screen ? setLyaout(!small_screen) : '';
          }
          else {
              !small_screen ? setLyaout(!small_screen) : '';
          }
      });
  })

  return (
    <Fragment>
      {
        small_screen ?
        (
          <Fragment>
          <div className={`${styles.homecare_plan__container} cross-sell row`}>
            <ThemeProvider theme={theme}>
              <Hidden key="mobile" mdUp>
                <div className="container">
                  <Slider {...settings}>
                    {formatProducts(props.plans).map((product:any, index) => {
                      return (
                        <HomecareCard
                          // enablePremium={props.enablePremium}
                          handleEnterPhone={props.handleEnterPhone}
                          handleClickCustom={props.handleClickCustom}
                          plan={product}
                          benefits={props.specificBenefits ? props.specificBenefits[product.description] : []}
                          specificImages={props.specificImages ? getStaticPath(`/${props.specificImages[product.product_type]}`) : getStaticPath('/static/images/404.svg')}
                          onMouseEnter={(e) => {
                              setMousePosition(index)
                          }}
                          onMouseLeave={(e) => {
                              resetMousePosition()
                          }}
                          is_hovered={hover == index}
                        />
                      )
                    })}
                  </Slider>
                </div>
              </Hidden>
            </ThemeProvider>
          </div>
          </Fragment>
        )
        :
        (
          <div className={`${styles.homecare_plan__container} row`}>
            {formatProducts(props.plans).map((product:any, index) => {
              return (
                <HomecareCard
                  // enablePremium={props.enablePremium}
                  handleEnterPhone={props.handleEnterPhone}
                  handleClickCustom={props.handleClickCustom}
                  plan={product}
                  benefits={props.specificBenefits ? props.specificBenefits[product.description] : []}
                  specificImages={props.specificImages ? getStaticPath(`/${props.specificImages[product.product_type]}`) : getStaticPath('/static/images/404.svg')}
                  onMouseEnter={(e) => {
                      setMousePosition(index)
                  }}
                  onMouseLeave={(e) => {
                      resetMousePosition()
                  }}
                  is_hovered={hover == index}
                />
              )
            })}
          </div>
        )
      }
    </Fragment>
  )
}

export default HomecarePlans;
